import React, { Component } from 'react';
import Card from '../../components/card/Card';
import Label from '../../components/label/Label';
import Input from '../../inputs/input/Input';
import PrimaryButton from '../../components/primaryButton/PrimaryButton';
import toasts from '../../utils/toasts';
import userGroupSettingsManager from '../../utils/UserGroupSettingsManager';
import models from '../../model/models';
import './BloodCommUuidCard.scss';

export default class BloodCommUuidCard extends Component {
	constructor(props) {
		super(props);
		this.state = {
			uuid: '',
			uuidError: null,
			loading: true
		};
	}

	componentDidMount = async () => {
		await this.fetchExistingUuid();
		this.subscribeGroupId = models.user_group.onChange(this.getData);
	}
	componentWillUnmount = () => {
		models.user_group.unsubscribe(this.subscribeGroupId);
	}
	getData =() => {
	  this.setState({userGroup:models.user_group.obj()})
	};

	fetchExistingUuid = async () => {
		try {
			const userGroupId = localStorage.user_group_id;
			if (!userGroupId) {
				this.setState({ 
					loading: false,
					uuidError: 'User group ID not found'
				});
				return;
			}

			await userGroupSettingsManager.refresh(userGroupId);
			const existingUuid = userGroupSettingsManager.getSetting('bloodcomm_uuid');
			
			this.setState({
				uuid: existingUuid || '',
				loading: false
			});
		} catch (error) {
			console.error('Error fetching existing UUID:', error);
			this.setState({ 
				loading: false,
				uuidError: 'Error loading existing UUID'
			});
		}
	};

	_handleUuidChange = (value) => {
		this.setState({
			uuid: value,
			uuidError: null
		});
	};

	saveUuid = async () => {
		const { uuid } = this.state;
		
		if (!uuid) {
			this.setState({ uuidError: 'Please enter BloodCOMM UUID' });
			return;
		}

		if (uuid.length < 10) {
			this.setState({ uuidError: 'UUID must be at least 10 characters long' });
			return;
		}

		try {
			const user_group_id = localStorage.user_group_id;
			if (!user_group_id) {
				this.setState({ uuidError: 'User group ID not found' });
				return;
			}

			await userGroupSettingsManager.upsert({name:'bloodcomm_uuid',string_value: uuid, user_group_id});
			await userGroupSettingsManager.refresh(user_group_id);

			toasts.show('BloodCOMM UUID saved successfully');
			this.setState({
				uuidError: null,
			});
		} catch (error) {
			console.error('Error saving UUID:', error);
			this.setState({ uuidError: 'Error saving UUID: ' + (error.message || 'Unknown error') });
		}
	};

	render() {
		const { uuid, uuidError, loading } = this.state;
		const userGroup = this.state.userGroup || {};
		const agencyName = userGroup ? userGroup.name : '';
		const emailSubject = agencyName ? `Enable LogRx Integration - ${agencyName}` : 'Enable LogRx Integration';
		const emailBody = agencyName 
			? `Hello,\n\nI would like to request that the LogRx integration be enabled for my organization: ${agencyName}.\n\nThank you.`
			: 'Hello,\n\nI would like to request that the LogRx integration be enabled for my organization.\n\nThank you.';
		const mailtoLink = `mailto:support@deltadevteam.com?subject=${encodeURIComponent(emailSubject)}&body=${encodeURIComponent(emailBody)}`;
		
		if (loading) {
			return (
				<Card className="inner-card g-bloodcomm-uuid-card">
					<Label bold black>BloodCOMM Settings</Label>
					<div className="uuid-form">
						<div className="loading-message">
							<Label>Loading existing UUID...</Label>
						</div>
					</div>
				</Card>
			);
		}
		
		return (
			<Card className="inner-card g-bloodcomm-uuid-card">
				<Label bold black>BloodCOMM Settings</Label>
				<br/>

				<Label>1. Login to <a href="https://blood.dev/settings/organization" target="_blank" rel="noopener noreferrer" style={{color: 'inherit', textDecoration: 'underline', cursor: 'pointer'}}>https://blood.dev/settings/organization</a> to get your Organization UUID</Label>
				<br/>
				<Label>2. <a href={mailtoLink} style={{color: 'inherit', textDecoration: 'underline', cursor: 'pointer'}}>Email support to enable the LogRx integration</a></Label>
				<div className="uuid-form">
					<div className="form-group">
						<Label black>BloodCOMM Organization UUID</Label>
						<Input
							type="text"
							value={uuid}
							onChange={this._handleUuidChange}
							placeholder="Enter BloodCOMM UUID"
						/>
					</div>
					{uuidError && (
						<div className="error-message">
							<Label red>{uuidError}</Label>
						</div>
					)}
					<div className="uuid-actions">
						<PrimaryButton
							center
							onClick={this.saveUuid}
						>
							Save Organization UUID
						</PrimaryButton>
					</div>
				</div>
			</Card>
		);
	}
}



// WEBPACK FOOTER //
// ./src/cards/bloodCommUuidCard/BloodCommUuidCard.jsx